// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../../common/http.res.js");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var ChartId$ReactHooksTemplate = require("./chartId.res.js");
var ChartComponent$ReactHooksTemplate = require("./ChartComponent.res.js");
var InsightsFilters$ReactHooksTemplate = require("../filters/InsightsFilters.res.js");

function reducer(state, x) {
  if (typeof x !== "object") {
    switch (x) {
      case "FetchFiltersInProgress" :
          return {
                  loadingProduct: true,
                  loadingVoc: true,
                  loadingCorrelationData: state.loadingCorrelationData,
                  productCharts: state.productCharts,
                  vocCharts: state.vocCharts,
                  toggleFilter: state.toggleFilter,
                  filterPills: state.filterPills,
                  filters: state.filters,
                  currentFilter: state.currentFilter,
                  correlationData: state.correlationData
                };
      case "ToggleFilter" :
          return {
                  loadingProduct: state.loadingProduct,
                  loadingVoc: state.loadingVoc,
                  loadingCorrelationData: state.loadingCorrelationData,
                  productCharts: state.productCharts,
                  vocCharts: state.vocCharts,
                  toggleFilter: !state.toggleFilter,
                  filterPills: state.filterPills,
                  filters: state.filters,
                  currentFilter: state.currentFilter,
                  correlationData: state.correlationData
                };
      case "FetchProductChartsInProgress" :
      case "FetchVocChartsInProgress" :
          break;
      case "FetchCorrelationDataInProgress" :
          return {
                  loadingProduct: state.loadingProduct,
                  loadingVoc: state.loadingVoc,
                  loadingCorrelationData: true,
                  productCharts: state.productCharts,
                  vocCharts: state.vocCharts,
                  toggleFilter: state.toggleFilter,
                  filterPills: state.filterPills,
                  filters: state.filters,
                  currentFilter: state.currentFilter,
                  correlationData: state.correlationData
                };
      
    }
  } else {
    switch (x.TAG) {
      case "FetchedCorrelationData" :
          return {
                  loadingProduct: state.loadingProduct,
                  loadingVoc: state.loadingVoc,
                  loadingCorrelationData: state.loadingCorrelationData,
                  productCharts: state.productCharts,
                  vocCharts: state.vocCharts,
                  toggleFilter: state.toggleFilter,
                  filterPills: state.filterPills,
                  filters: state.filters,
                  currentFilter: state.currentFilter,
                  correlationData: x._0
                };
      case "FetchProductChartsCompleted" :
          return {
                  loadingProduct: false,
                  loadingVoc: state.loadingVoc,
                  loadingCorrelationData: state.loadingCorrelationData,
                  productCharts: x._0,
                  vocCharts: state.vocCharts,
                  toggleFilter: state.toggleFilter,
                  filterPills: state.filterPills,
                  filters: state.filters,
                  currentFilter: state.currentFilter,
                  correlationData: state.correlationData
                };
      case "SetFiltersAndPills" :
          return {
                  loadingProduct: true,
                  loadingVoc: true,
                  loadingCorrelationData: true,
                  productCharts: state.productCharts,
                  vocCharts: state.vocCharts,
                  toggleFilter: state.toggleFilter,
                  filterPills: x._1,
                  filters: x._0,
                  currentFilter: state.currentFilter,
                  correlationData: state.correlationData
                };
      case "SetFilters" :
          return {
                  loadingProduct: state.loadingProduct,
                  loadingVoc: state.loadingVoc,
                  loadingCorrelationData: state.loadingCorrelationData,
                  productCharts: state.productCharts,
                  vocCharts: state.vocCharts,
                  toggleFilter: state.toggleFilter,
                  filterPills: state.filterPills,
                  filters: x._0,
                  currentFilter: state.currentFilter,
                  correlationData: state.correlationData
                };
      case "FetchVocChartsCompleted" :
          return {
                  loadingProduct: state.loadingProduct,
                  loadingVoc: false,
                  loadingCorrelationData: state.loadingCorrelationData,
                  productCharts: state.productCharts,
                  vocCharts: x._0,
                  toggleFilter: state.toggleFilter,
                  filterPills: state.filterPills,
                  filters: state.filters,
                  currentFilter: state.currentFilter,
                  correlationData: state.correlationData
                };
      
    }
  }
  return {
          loadingProduct: true,
          loadingVoc: state.loadingVoc,
          loadingCorrelationData: state.loadingCorrelationData,
          productCharts: state.productCharts,
          vocCharts: state.vocCharts,
          toggleFilter: state.toggleFilter,
          filterPills: state.filterPills,
          filters: state.filters,
          currentFilter: state.currentFilter,
          correlationData: state.correlationData
        };
}

var initialState_correlationData = {
  categories: /* [] */0,
  data: null
};

var initialState = {
  loadingProduct: true,
  loadingVoc: true,
  loadingCorrelationData: true,
  productCharts: undefined,
  vocCharts: undefined,
  toggleFilter: false,
  filterPills: /* [] */0,
  filters: /* [] */0,
  currentFilter: 0,
  correlationData: initialState_correlationData
};

var style = {
  lineWidth: 1,
  stroke: "#fff"
};

function Insights(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var fetchVisualizations = function (param) {
    Js_promise.then_((function (xs) {
            return Js_promise.then_((function (param) {
                          return Js_promise.then_((function (xs) {
                                        return Promise.resolve(Js_promise.then_((function (param) {
                                                          return Js_promise.then_((function (xs) {
                                                                        return Promise.resolve((setTimeout((function (param) {
                                                                                            Curry._1(dispatch, {
                                                                                                  TAG: "FetchedCorrelationData",
                                                                                                  _0: xs
                                                                                                });
                                                                                          }), Utils$ReactHooksTemplate.timeout), undefined));
                                                                      }), Js_promise.then_((function (xs) {
                                                                            console.log(xs);
                                                                            return Promise.resolve(xs);
                                                                          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/insights/correlation_data", (function (json) {
                                                                                return {
                                                                                        categories: Json_decode.field("categories", (function (param) {
                                                                                                return Json_decode.list(Json_decode.string, param);
                                                                                              }), json),
                                                                                        data: Belt_Option.getWithDefault(Js_json.decodeObject(json), {})["data"]
                                                                                      };
                                                                              }))));
                                                        }), Promise.resolve((setTimeout((function (param) {
                                                                    Curry._1(dispatch, {
                                                                          TAG: "FetchVocChartsCompleted",
                                                                          _0: xs
                                                                        });
                                                                  }), Utils$ReactHooksTemplate.timeout), undefined))));
                                      }), Js_promise.then_((function (xs) {
                                            console.log(xs);
                                            return Promise.resolve(xs);
                                          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/insights/visualizations?session=voc", ChartId$ReactHooksTemplate.fromJson)));
                        }), Promise.resolve(setTimeout((function (param) {
                                  Curry._1(dispatch, {
                                        TAG: "FetchProductChartsCompleted",
                                        _0: xs
                                      });
                                }), Utils$ReactHooksTemplate.timeout)));
          }), Js_promise.then_((function (xs) {
                console.log(xs);
                return Promise.resolve(xs);
              }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/insights/visualizations?session=product", ChartId$ReactHooksTemplate.fromJson)));
  };
  React.useEffect((function (param) {
          fetchVisualizations();
        }), []);
  var onApplyFilter = function (param) {
    fetchVisualizations();
  };
  var toggleFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
    Curry._1(dispatch, {
          TAG: "SetFilters",
          _0: state.filters
        });
  };
  var tmp;
  if (state.loadingProduct) {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("p", {
                children: "Loading..."
              })
        });
  } else {
    var xs = state.productCharts;
    tmp = xs !== undefined ? $$Array.of_list(List.map((function (chartId) {
                  return JsxRuntime.jsx(ChartComponent$ReactHooksTemplate.make, {
                              chartId: chartId,
                              onClick: (function (param, param$1, param$2) {
                                  
                                }),
                              onEnlarge: (function (param) {
                                  
                                }),
                              insight: true
                            }, String(ChartId$ReactHooksTemplate.id(chartId)));
                }), xs)) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  var tmp$1;
  if (state.loadingVoc) {
    tmp$1 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("p", {
                children: "Loading..."
              })
        });
  } else {
    var xs$1 = state.vocCharts;
    tmp$1 = xs$1 !== undefined ? $$Array.of_list(List.map((function (chartId) {
                  return JsxRuntime.jsx(ChartComponent$ReactHooksTemplate.make, {
                              chartId: chartId,
                              onClick: (function (param, param$1, param$2) {
                                  
                                }),
                              onEnlarge: (function (param) {
                                  
                                }),
                              insight: true
                            }, String(ChartId$ReactHooksTemplate.id(chartId)) + "5");
                }), xs$1)) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsxs("div", {
                        children: [
                          state.toggleFilter ? JsxRuntime.jsx(InsightsFilters$ReactHooksTemplate.make, {
                                  onClose: toggleFilter,
                                  onApply: onApplyFilter,
                                  showDateFilter: false,
                                  showFilterPills: false,
                                  correlation: false
                                }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: "Active Filters",
                                                className: "flex items-center font-normal text-sm h-8"
                                              }),
                                          JsxRuntime.jsx(InsightsFilters$ReactHooksTemplate.make, {
                                                onClose: toggleFilter,
                                                onApply: onApplyFilter,
                                                showDateFilter: false,
                                                showFilterPills: true,
                                                correlation: false
                                              })
                                        ],
                                        className: "flex flex-wrap gap-2"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-14-px mr-2-px",
                                                      src: Image$ReactHooksTemplate.filterButton
                                                    }),
                                                "Filters"
                                              ],
                                              className: "bg-ghostwhite border border-gray-400\n                              shadow-inner flex rounded py-2 px-3 text-xs",
                                              id: "filters",
                                              onClick: (function (param) {
                                                  toggleFilter();
                                                })
                                            }),
                                        className: "float-right"
                                      })
                                ],
                                className: "px-16-px flex justify-between pb-20-px"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      className: "w-3 bg-red-600 h-10 mr-2"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "PRODUCT / SERVICE IMPACT",
                                                      className: "text-lg font-extrabold"
                                                    })
                                              ],
                                              className: "flex items-center"
                                            }),
                                        className: "w-full border mb-2 bg-white h-10"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: tmp,
                                        className: "flex flex-wrap"
                                      })
                                ],
                                className: "flex flex-col"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      className: "w-3 bg-red-600 h-10 mr-2"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "VOC IMPACT",
                                                      className: "text-lg font-extrabold"
                                                    })
                                              ],
                                              className: "flex items-center mr-16"
                                            }),
                                        className: "w-full border mb-2 bg-white h-10"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: tmp$1,
                                        className: "flex flex-wrap"
                                      })
                                ],
                                className: "flex flex-col"
                              })
                        ],
                        className: "p-20-px bg-porcelain"
                      }))
            });
}

var make = Insights;

exports.reducer = reducer;
exports.initialState = initialState;
exports.style = style;
exports.make = make;
/* initialState Not a pure module */
